import { createSlice } from "@reduxjs/toolkit";

interface OptionsState {
    optionsActive: boolean;
    option?: "columns";
}

const initialState: OptionsState = {
    optionsActive: false,
};

const preferencesSlice = createSlice({
    name: "preferences/slice",
    initialState,
    reducers: {
        setOptionsActive: (state, action) => {
            state.optionsActive = action.payload;
        },
        setOption: (state, action) => {
            state.option = action.payload;
        },
    },
});

export const {
    setOption,
    setOptionsActive
} = preferencesSlice.actions;

export default preferencesSlice.reducer;
